<ng-container
	*ngLet="{
		coacheeNotes: controller.coacheeNotes$ | async,
		sessionUser: controller.sessionUser$ | async,
		coachee: controller.coachee$ | async
	} as data"
>
	<div
		class="md:flex-none md:w-52 grid grid-cols-3 md:grid-cols-1 gap-6 break-word"
	>
		<div class="md:hidden">
			{{ controller.i18n + '.table.column.date' | translate }}
		</div>
		<div class="col-span-2 md:justify-self-start justify-self-end">
			{{
				note.creationTimestamp
					| moment: 'LL':data.sessionUser.timeZone:data.sessionUser.metadata.language
			}}
		</div>
	</div>
	<div class="md:flex-1 grid grid-cols-3 md:grid-cols-1 gap-6">
		<div class="md:hidden">
			{{ controller.i18n + '.table.column.note' | translate }}
		</div>
		<div
			class="
				col-span-2
				md:flex md:flex-wrap md:text-left
				text-justify
				md:justify-self-start
				justify-self-end
			"
		>
			{{ note.note }}
		</div>
	</div>
	<div class="md:flex-none md:w-16 flex justify-end lg:space-x-3 md:space-x-1">
		<ng-content></ng-content>
	</div>
</ng-container>
